module.exports = __webpack_public_path__ + "img/panels_serial02.02a73e7f.gif";